import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { ApplicationUser } from '../../../core/models/application-user';
import { UserService } from 'src/app/core/services/user.service';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [DatePipe],
  host: {
    '(document:click)': 'onClick($event)',
  },
})
export class HeaderComponent implements OnInit {
  drop:boolean=false;
  noti:boolean=false;
  navbarOpen = false;
  name: any;
  user: ApplicationUser;
  notificationData=[];
  count: any;
  readCount: any;
  total: any=0;
  p: any=0;
  isPendingPI: boolean = false;
  isCompletedPI: boolean = false;
  isInprogressPI: boolean = false;

  isPendingUD: boolean = false;
  isCompletedUD: boolean = false;
  isInprogressUD: boolean = false;

  isPendingSA: boolean = false;
  isCompletedSA: boolean = false;
  isInprogressSA: boolean = false;

  isPendingOT: boolean = false;
  isCompletedOT: boolean = false;
  isInprogressOT: boolean = false;
  tb4: boolean = false;
  error: any;
  personalinfo: any;
  isUploadDocument: boolean = false;
  isSignAgreement: boolean = false;
  isOnlineTraining: boolean = false;

  isSignAgreement1: boolean = true;
  isUploadDocument1: boolean = true;
  isOnlineTraining1: boolean = true;
  completed: boolean = false;
  incompleted0: boolean = false;
  incompleted1: boolean = false;
  incompleted2: boolean = false;
  incompleted3: boolean = false;
  isPending: boolean = true;
  isPendingTraining: boolean = false;
  isPendingContract: boolean = false;
  isPendingDoc: boolean = false;
  isInprogressContract: boolean = false;
  isInprogressTraining: boolean = false;
  titleNavUD:string="";
  titleNavSA:string="";
  titleNavOT:string="";
  logoNavigate : boolean = false;
  showAgencyCode: any;
  leadStatus: any;
  toggleNavbar() {
  this.navbarOpen = !this.navbarOpen;
  }
  constructor(private _eref: ElementRef,public router: Router,private authservice: AuthenticationService, private users: UserService,private DatePipe:DatePipe) {
   // this.name=sessionStorage.getItem("username");
   localStorage.removeItem('ssl_result_message');
this.name=sessionStorage.getItem("username");
  
   }

  ngOnInit(): void {
    
    this.getNotification();
    this.getDashboard();
    this.showAgencyCode=sessionStorage.getItem('agencyCodeSalesPortal');
   }
  toggleShowone() {
    this.drop = !this.drop;
   if (this.drop) {
     this.drop = true;
     this.noti = false;

   }
   else {
     this.drop = false;
   }
   
 }
 notificationShow() {
  this.noti = !this.noti;
 if (this.noti) {
   this.noti = true;
   this.drop = false;
  //  this.users.getNotification().subscribe(
  //   data => {
  //     this.notificationData=[];
  //    this.notificationData=data.data.notifications;
  //    this.count = data.data.unreadCount;
  //   },error=>{ },()=>{});
 }
 else {
   this.noti = false;
 }
}
onClick(event) {
  if (!this._eref.nativeElement.contains(event.target)) 
  {
   this.drop = false;
   this.noti = false;

  }
}
logout() {
  this.authservice.logout();
  sessionStorage.setItem('selectedMgaIdDoc', 'false');
  sessionStorage.setItem('selectedMgaIdDocCheck', 'false');
  sessionStorage.setItem('selectedMgaIdDocDeactivated', 'false'); 
  sessionStorage.removeItem('agencyCodeSalesPortal');
  sessionStorage.removeItem('agentIdSalesPortal');
  sessionStorage.removeItem('agentIdS');
  localStorage.removeItem('searchCriteria');
  localStorage.removeItem('email');
localStorage.removeItem('pass');
localStorage.removeItem('fcmToken');
}

filterHistory=[];
getNotification(){
  this.users.getNotification().subscribe(
    data => {
     this.notificationData=data.data.notifications;
     this.count = data.data.unreadCount;
     this.total = data.data.total;
     this.filterHistory=data.data.notifications.filter(v=>v.id != null|| undefined);
     const groups = this.filterHistory.reduce((groups, notification) => {
     const date = notification.createdAt.split('T')[0];
     let latest_date =this.DatePipe.transform(date, 'dd MMM');
    
     if (!groups[latest_date]) {
       groups[latest_date] = [];
     }
     groups[latest_date].push(notification);
     return groups;
   }, {});
   
   // Edit: to add it in the array format instead
   const groupArrays = Object.keys(groups).map((date) => {
     return {
       date,
       leads: groups[date]
     };
   });
   
   
  //  this.filterHistory=groupArrays;
  this.filterHistory=groupArrays;
    },error=>{ },()=>{});
}

getNotificationAfterCheck(){
  this.noti = true;
  this.users.getNotification().subscribe(
    data => {
      this.noti = true;
     this.notificationData=data.data.notifications;
     this.count = data.data.unreadCount;
     this.readCount= data.data.readCount;
     this.total = data.data.total;
    //  if(this.count>100){
    //    this.count1=true;
    //  }else{
    //   this.count1=false;
    //  }
     this.filterHistory=data.data.notifications.filter(v=>v.id != null|| undefined);
  const groups = this.filterHistory.reduce((groups, notification) => {
  const date = notification.createdAt.split('T')[0];
  let latest_date =this.DatePipe.transform(date, 'dd MMM');
 
  if (!groups[latest_date]) {
    groups[latest_date] = [];
  }
  groups[latest_date].push(notification);
  return groups;
}, {});

// Edit: to add it in the array format instead
const groupArrays = Object.keys(groups).map((date) => {
  return {
    date,
    leads: groups[date]
  };
});


this.filterHistory=groupArrays;
// for(let i=this.filterHistory.length; i>0;i--){
//   this.filterArray.push(this.filterHistory[i]);
// }
// console.log(this.filterHistory)
// console.log(this.filterArray)
    },error=>{ },()=>{});
}

OnRead(notificationId){
  this.noti = true;
   this.users.notificationRead(notificationId).subscribe(
    data => {
      this.getNotificationAfterCheck();
      this.noti = true;
    },error=>{ },()=>{});
}

OnReadAll(){
  this.noti = true;
   this.users.notificationAllRead().subscribe(
    data => {
      this.getNotificationAfterCheck();
      this.noti = true;
    },error=>{ },()=>{});
}

pageChnageDone(data){
  var page=data;
  this.noti = true;
  this.users.getNotificationByPage(page).subscribe(
    data => {
      this.noti = true;
     this.notificationData=data.data.notifications;
     this.count = data.data.unreadCount;
     this.readCount= data.data.readCount;
     this.total = data.data.total
    //  if(this.count>100){
    //    this.count1=true;
    //  }else{
    //   this.count1=false;
    //  }
     this.filterHistory=data.data.notifications.filter(v=>v.id != null|| undefined);
  const groups = this.filterHistory.reduce((groups, notification) => {
  const date = notification.createdAt.split('T')[0];
  let latest_date =this.DatePipe.transform(date, 'dd MMM');
 
  if (!groups[latest_date]) {
    groups[latest_date] = [];
  }
  groups[latest_date].push(notification);
  return groups;
}, {});

// Edit: to add it in the array format instead
const groupArrays = Object.keys(groups).map((date) => {
  return {
    date,
    leads: groups[date]
  };
});


this.filterHistory=groupArrays;
    },error=>{ },()=>{});
}

onClickMessage(data){
if(data =="More information required on uploaded license" || data =="More information required on uploaded documents" || data =="Uploaded license is approved" ||
data =="Uploaded license are not approved" || data =="Uploaded document is approved" || data =="Uploaded documents are not approved" || data =="Uploaded documents are approved" || data =="Uploaded license are approved"
|| data =="More information required for uploaded documents " || data =="More information required for uploaded license" || data =="More info required for uploaded license"
){
this.router.navigateByUrl("/dashboard/upload-documents");
this.noti = false;
}
if(data =="More information required to complete  agreement" || data =="Travelance agreement is ready to sign. Incomplete agreements expire after 90 days." || data == "Travelance agreement is approved"){
  this.router.navigateByUrl("/dashboard/contract-sign");
  this.noti = false;
  }

    
}
getDashboard() {
  this.users.getDashboardData().pipe()
    .subscribe(
      data => {
  
        this.personalinfo = data.data.leads;

        sessionStorage.setItem('leadId', data.data.leads.leadId)
        if (this.personalinfo.stagesViews != null || undefined) {
          sessionStorage.setItem('stagesViews', JSON.stringify(this.personalinfo.stagesViews))

          if (this.personalinfo.stagesViews[0].isCompleted === true && this.personalinfo.stagesViews[0].isApproved === true) {

            this.isCompletedPI = true;
            this.titleNavUD=""
          }
          if (this.personalinfo.stagesViews[0].isCompleted === false && this.personalinfo.stagesViews[0].isApproved === false) {

            this.isPendingPI = true;
            this.titleNavUD="Upload Documents will be active once the Personal Info is submitted"
          }
          else if (this.personalinfo.stagesViews[0].isCompleted === true && this.personalinfo.stagesViews[0].isApproved === false) {

            this.isInprogressPI = true;
            this.titleNavUD="Upload Documents will be active once the Personal Info is submitted"
          }

          if (this.personalinfo.stagesViews[1].isCompleted === true && this.personalinfo.stagesViews[1].isApproved === true) {
           
            this.isCompletedUD = true
            this.titleNavSA=""
            this.titleNavOT=""
            
          }
          if (this.personalinfo.stagesViews[1].isCompleted === false && this.personalinfo.stagesViews[1].isApproved === false) {
            
            this.isPendingUD = true;
            this.titleNavSA="Sign Agreement will be active once the uploaded Documents are approved"
            this.titleNavOT="Online Training will be active once the uploaded Documents are approved"
          }
          if (this.personalinfo.stagesViews[1].isCompleted === true && this.personalinfo.stagesViews[1].isApproved === false) {

            this.isInprogressUD = true;
            this.titleNavSA="Sign Agreement will be active once the uploaded Documents are approved"
            this.titleNavOT="Online Training will be active once the uploaded Documents are approved"
          }

          if (this.personalinfo.stagesViews[2].isCompleted === true && this.personalinfo.stagesViews[2].isApproved === true) {
            
           this.isCompletedSA=true;
           this.titleNavOT=""
          }
          if (this.personalinfo.stagesViews[2].isCompleted === false && this.personalinfo.stagesViews[2].isApproved === false) {
            
            this.isPendingSA=true;
            //this.titleNavOT="Online Training will be active once the uploaded Documents are approved"

          }
          if (this.personalinfo.stagesViews[2].isCompleted === true && this.personalinfo.stagesViews[2].isApproved === false) {

           
            this.isInprogressSA=true;
            //this.titleNavOT="Online Training will be active once the uploaded Documents are approved"
          }
          if (this.personalinfo.stagesViews[3].isCompleted === true && this.personalinfo.stagesViews[3].isApproved === true) {
           
            this.isCompletedOT=true;
          }
          if (this.personalinfo.stagesViews[3].isCompleted === false && this.personalinfo.stagesViews[3].isApproved === false) {
            
            this.isPendingOT=true;

          }
          if (this.personalinfo.stagesViews[3].isCompleted === true && this.personalinfo.stagesViews[3].isApproved === false) {

           
            this.isInprogressOT=true;
          }
         
        }
      }, error => {

        if (error.status == 400 || error.status == 417) {
          this.error = error.error.data;

        }
        else {

          this.error = "Something went wrong. Please Try again later.";
        }

      }, () => { });

}
onClickLogo(){
  this.leadStatus=sessionStorage.getItem('leadStatus');
  if (this.leadStatus=="Activated" || this.leadStatus=="Deactivated"){
    this.logoNavigate = true;
    this.router.navigate(['/activated']);
    localStorage.removeItem('filterStatus');
    localStorage.removeItem('filterStatusIndex');
    setTimeout(() =>{
      window.location.reload(); // Reload the page ignoring the cache
    },
    50);
  }
  else
  {
    this.logoNavigate = false;
    this.router.navigate(['/dashboard']);
    localStorage.removeItem('filterStatus');
    localStorage.removeItem('filterStatusIndex');
    setTimeout(() =>{
      window.location.reload(); // Reload the page ignoring the cache
    },
    50);

  }
  // if(this.isCompletedPI == true && this.isCompletedUD == true && this.isCompletedSA == true && this.isCompletedOT == true)
  // {
  //   this.logoNavigate = true;
  //   this.router.navigate(['/activated']);
  //   localStorage.removeItem('filterStatus');
  //   localStorage.removeItem('filterStatusIndex');
  //   setTimeout(() =>{
  //     window.location.reload(); // Reload the page ignoring the cache
  //   },
  //   50);
  // }
  // else
  // {
  //   this.logoNavigate = false;
  //   this.router.navigate(['/dashboard']);
  //   localStorage.removeItem('filterStatus');
  //   localStorage.removeItem('filterStatusIndex');
  //   setTimeout(() =>{
  //     window.location.reload(); // Reload the page ignoring the cache
  //   },
  //   50);
  // }
}
onRefreshClick() {
  ////
  // Request a hard refresh
  window.location.reload();
}
}
